import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { forgotPassword } from '../http/auth.js';
import styled from 'styled-components';
import { Alert } from '../components/Ui/Alert.jsx';
import { getCookie } from '../http/auth.js';
import logoSmall from '../assets/MCR-V-4.png';
import { isMobile } from 'react-device-detect';

const LoginContainer = styled.div`
  max-width: 550px;
  padding: 20px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  background: #fff;

  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #f0f0f0;
`;


const Title = styled.h2`
  color: #333;
  margin-bottom: 0.5em;
  font-weight: 600;
`;

const Subtitle = styled.p`
  color: #666;
  margin-top: 0;
  margin-bottom: 2em;
`;

const Form = styled.div`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
`;

const Button = styled.button`
  padding: 10px;
  background-color: ${props => props.disabled ? '#cccccc' : '#4a90e2'};
  color: white;
  border: none;
  border-radius: 4px;
  margin-top: 20px;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    background-color: ${props => props.disabled ? '#cccccc' : '#357abd'};
  }
`;

const Spinner = styled.div`
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top: 2px solid white;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  line-height: 15px;
`;

export default function ForgotPassword() {
  const [username, setUsername] = useState();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [warning, setWarning] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleForgotPassword = async () => {

    if (!username) {
      setWarning({ message: "Please enter your email address" });
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(username)) {
      setWarning({ message: "Please enter a valid email address" });
      return;
    }
    setWarning(null);
    setError(null);
    setLoading(true);

    try {
      const res = await forgotPassword(username);
      setError({ message: "Password reset email sent successfully", type: "success" });
    } catch (e) {
      setError({ message: e.message || "Failed to send password reset email" });
    } finally {

    }
    setLoading(false);
    navigate('/login?reset=true');
  }

  return (
    <Wrapper>
      <LoginContainer>
        <Container>
          <img src={isMobile ? logoSmall : logoSmall} alt="Logo" />
          <Title>MCR EyeTicket</Title>
          <Subtitle>Please enter the email address that your account is registered to and a password reset email will be sent shortly</Subtitle>
        </Container>
        <Form>
          <Input
            name="Email"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Email"
            autoComplete="username"
            disabled={loading}
          />

          {error && <Alert type={error.type || "error"}>{error.message}</Alert>}
          {warning && <Alert type="warning">{warning.message}</Alert>}
          <Button onClick={handleForgotPassword} disabled={loading}>
            {loading && <Spinner />}
            {loading ? 'Sending...' : 'Send Password Reset Email'}
          </Button>
        </Form>
      </LoginContainer>
    </Wrapper>
  );
}
